
	export default {
		props: {
			item: Object,
			url: String,
			loggedIn: {
				type: Boolean,
				default: false
			},
			hoverLink: {
				type: Boolean,
				default: true
			},
			showStars: {
				type: Boolean,
				default: true
			},
			showButtons: {
				type: Boolean,
				default: true
			},
			showBanners: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				moreInfo: false,
				showCollections: false,
				bannerStyle: `transform:rotate(-35deg);margin-left:-2.5rem;margin-top:.1rem`,
				bannerClass: `position-absolute text-light top-0 start-0 py-2 text-center px-5`
			}
		},
		methods: {
			triggerCollectionsModal() {
				if (!this.loggedIn) location.href = `/login`;
				else this.showCollections = true;
			}
		}
	}

